// Add your custom JS here.

/** Custom js for Rico Limmen
 * 
 * 1. Subnav scrollspy
 * 2. Scroll top button
 * 3. Preloader
 * 4. Sticky #sub-menu navbar
 */

/** 1. Subnav scrollspy 
 * (because original Bs scrollspy doesn't work in the new version)
 */
document.addEventListener('DOMContentLoaded', () => {
    const navLinks = document.querySelectorAll('#sub-menu .dropdown-item');
    const sections = [];

    // 1. Find all sections that have a corresponding link in the menu
    navLinks.forEach(link => {
        const id = link.getAttribute('href');
        if (id.startsWith('#')) {
            const section = document.querySelector(id);
            if (section) sections.push(section);
        }
    });

    // 2. Observer Settings
    const options = {
        root: null,
        rootMargin: '-10% 0px -80% 0px', // Triggers when section is near the top
        threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Remove active class from all links
                navLinks.forEach(link => link.classList.remove('active'));
                
                // Add active class to the link matching the current section ID
                const activeLink = document.querySelector(`#sub-menu a[href="#${entry.target.id}"]`);
                if (activeLink) {
                    activeLink.classList.add('active');
                    
                    // Optional: Highlight the parent dropdown title too
                    const parentTitle = activeLink.closest('.dropdown').querySelector('.nav-link');
                    document.querySelectorAll('#sub-menu .nav-link').forEach(nav => nav.classList.remove('active'));
                    if (parentTitle) parentTitle.classList.add('active');
                }
            }
        });
    }, options);

    // 3. Start observing each section
    sections.forEach(section => observer.observe(section));
});

/** 2. Scroll top button
 */

document.addEventListener('DOMContentLoaded', () => {
    // 1. Cache the element outside the listener
    const topButton = document.querySelector('.top-button');

    window.addEventListener('scroll', () => {
      // 2. Use requestAnimationFrame to sync with the browser's refresh rate
      window.requestAnimationFrame(() => {
        if (window.scrollY >= 500) {
          topButton.classList.add('visible');
        } else {
          topButton.classList.remove('visible');
        }
      });
    }, { passive: true }); // 3. 'passive: true' tells the browser scroll won't be blocked
});


/** 3. Preloader
 */
  // window.onload = function (e) {
  //     const elm = document.querySelector("body");
  //     const elm_class = "page_loaded";
  //     elm.classList.add(elm_class);
  // };

document.addEventListener("DOMContentLoaded", function () {
  let ignoreOnBeforeUnload = false;
  const preloader = document.getElementById("page-preloader");

  // Exclude links to fade-in
  document.querySelectorAll(
    'a[href^="mailto"], a[href^="tel"], a[data-fade="false"], .woocommerce-MyAccount-downloads-file'
  ).forEach(link => {
    link.addEventListener("click", () => {
      ignoreOnBeforeUnload = true;
    });
  });

  // Preloader
  window.addEventListener("beforeunload", function () {
    if (!ignoreOnBeforeUnload) {
      preloader.classList.remove("hidden");
    }
    ignoreOnBeforeUnload = false;
  });
  window.addEventListener("load", function () {
    preloader.classList.add("hidden");
  });
  setTimeout(() => {
    preloader.classList.add("hidden");
  }, 1500);

  // Prevents preloader getting stuck with back/forward
  window.onpagehide = function () {
    preloader.classList.add("hidden");
  };
});


